"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadI18n = void 0;
const tslib_1 = require("tslib");
function loadI18n(locale) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        switch (locale) {
            case "en_us":
                return (yield Promise.resolve().then(() => tslib_1.__importStar(require("./i18n.en_us")))).i18n_en_us();
            case "de_de":
                return (yield Promise.resolve().then(() => tslib_1.__importStar(require("./i18n.de_de")))).i18n_de_de();
        }
    });
}
exports.loadI18n = loadI18n;
